export const S3_PUBLIC_URL = "https://ydms-public.s3.ap-southeast-1.amazonaws.com/"